<template>
    <base-form :formType="'memberRegister'">
     
    </base-form>
  </template>
  
  <script>
  import BaseForm from "./BaseForm.vue";
  
  export default {
    components: { BaseForm },
    data() {
      return {
        formData: {}, // 用于 BaseForm 提交后复用
        questionCategories: ["技术问题", "售后服务", "其他"], // 咨询问题分类
      };
    },
    mounted(){
      this.initShare();
        this.$dataStatistics({
            page_title: `会员注册`,
        },'访问');
    },
  };
  </script>